<modal id="about-course">
	<div class="modal">
		<div class="modal__header">
			<div class="modal__back" (click)="closeModal('about-course');">
				<img class="modal__back-icon" src="assets/images/education/icons/icon__back-arrow.svg" alt="">
				Назад
			</div>
			<h2 class="modal__title" *ngIf="data">{{data.name}}</h2>
			<img class="modal__cross" (click)="closeModal('about-course');" src="assets/images/education/icons/icon__cross.svg" alt="">
		</div>
		<div class="modal__inner">
			<div class="modal__item">
				<h3 class="modal__item-title">Описание:</h3>
				<div class="modal__content" *ngIf="data" [innerHTML]="data.detail_description"></div>
			</div>

			<div class="modal__item">
				<h3 class="modal__item-title">Как будет проходить интенсив / стажировка:</h3>
				<div class="modal__content" *ngIf="data" [innerHTML]="data.intensive_description"></div>
			</div>

			<div class="modal__item">
				<h3 class="modal__item-title">Кому подходит:</h3>
				<div class="modal__content" *ngIf="data" [innerHTML]="data.suitable_description"></div>
			</div>

			<form action="" class="form" [formGroup]="form">
				<h2 class="modal__item-title">Заполнить данные о себе:</h2>
				<div class="form__inner">
					<div class="form__left">
						<div class="form__row">
							<input class="form__input" type="text" formControlName="full_name" placeholder="Ф.И.О*"
								   [class.form__input--error]="form.controls['full_name'].invalid && form.controls['full_name'].touched">
						</div>
						<div class="form__row">
							<div class="form__block">
								<input class="form__input" type="text" formControlName="email" placeholder="E-MAIL*"
									   (ngModelChange)="onInputChange('email')"
									   [class.form__input--error]="form.controls['email'].invalid && form.controls['email'].touched">
								<label *ngIf="errorMessage?.email">{{errorMessage?.email}}</label>
							</div>
							<div class="form__block">
								<input class="form__input" type="text" formControlName="phone" mask="+0 (000) 000-00-00" placeholder="Телефон*"
									   (ngModelChange)="onInputChange('phone')"
									   [class.form__input--error]="form.controls['phone'].invalid && form.controls['phone'].touched">
								<label *ngIf="errorMessage?.phone">{{errorMessage?.phone}}</label>
							</div>
						</div>
						<div class="form__row" *ngIf="idDirection === 1">
							<div class="form__block">
								<input class="form__input" type="text" formControlName="portfolio_link" placeholder="Ссылка для портфолио"
									   (ngModelChange)="onInputChange('portfolio_link')"
									   [class.form__input--error]="form.controls['portfolio_link'].invalid && form.controls['portfolio_link'].touched">
								<label *ngIf="errorMessage?.portfolio_link">{{errorMessage?.portfolio_link}}</label>
							</div>
						</div>
						<div class="form__row form__row--height">
							<textarea class="form__input form__input--height"
									  [(ngModel)]="text"
									  (input)="countCharacters()"
									  formControlName="telegram"
									  maxlength="10000"
									  placeholder="Расскажи пару слов о себе*"></textarea>
							<p class="form__count">{{ characterCount }} / 10000</p>
						</div>
					</div>
					<div class="form__right">
						<label>
							<input type="file"
								   formControlName="file"
								   class="form__file"
								   id="fileInput"
								   (change)="onChange($event)"
								   accept=".pdf,.doc,.docx">
							<div *ngIf="!fileSelected" class="form__input-file">
								<span *ngIf="!fileSelected">Прикрепить резюме</span>
								<img *ngIf="!fileSelected" class="form__icon-file"
									 src="assets/images/education/icons/icon__attach-file.svg"
									 alt="">
							</div>
							<div *ngIf="fileSelected" class="form__input-file" [class.form__input-file--selected]="fileSelected">
								<span>Резюме загружено</span>
								<img class="form__icon-file"
									 src="assets/images/education/icons/icon__upload-file.svg"
									 alt="">
								<button class="form__button-file" *ngIf="fileSelected">Обновить</button>
							</div>
						</label>
						<label *ngIf="idDirection === 1">
							<input type="file"
								   formControlName="portfolio"
								   class="form__file"
								   (change)="onChangePortfolio($event)"
								   accept=".pdf,.doc,.docx">
							<div *ngIf="!fileSelectedPortfolio" class="form__input-file">
								<span *ngIf="!fileSelectedPortfolio">Прикрепить портфолио</span>
								<img *ngIf="!fileSelectedPortfolio" class="form__icon-file"
									 src="assets/images/education/icons/icon__attach-file.svg"
									 alt="">
							</div>
							<div *ngIf="fileSelectedPortfolio" class="form__input-file" [class.form__input-file--selected]="fileSelectedPortfolio">
								<span>Портфолио загружено</span>
								<img class="form__icon-file"
									 src="assets/images/education/icons/icon__upload-file.svg"
									 alt="">
								<button class="form__button-file" *ngIf="fileSelectedPortfolio">Обновить</button>
							</div>
						</label>
					</div>
				</div>

				<div class="form__comment">* - обязательные поля</div>

				<div class="form__checkbox">
					<input type="checkbox" class="custom-checkbox" formControlName="personalDataPolicy" id="checkbox">
					<label for="checkbox">Нажимая на кнопку, Вы соглашаетесь c <a href="assets/file/personal-data-policy.pdf" target="_blank">политикой обработки персональных данных</a></label>
				</div>

				<div class="form__checkbox">
					<input type="checkbox" class="custom-checkbox" formControlName="personalData" id="checkbox2">
					<label for="checkbox2">Нажимая на кнопку, Вы даете согласие на <a href="assets/file/personal-data.pdf" target="_blank">обработку персональных данных</a></label>
				</div>

				<button class="form__button"
						type="submit"
						[ngClass]="form.invalid ? 'form__button--disabled' : ''"
						[disabled]="form.invalid"
						(click)="onSubmit()">
					Подать заявку
				</button>
			</form>
		</div>

		<div class="curator">
			<div class="curator__photo" *ngIf="data">
				<img src="{{environment.url}}{{data.image}}" alt="">
			</div>
			<div class="curator__info">
				<h2 class="curator__title">Кто будет твоим куратором?</h2>
				<h2 class="curator__name" *ngIf="data">{{data.host_name}}</h2>
				<p class="curator__text" *ngIf="data">{{data.host_info}}</p>
			</div>
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('about-course');"></div>
</modal>
